import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { WorkspaceSummary } from '@helios/state-management'
import { DeleteWorkspaceConfirmationComponent } from './delete-workspace-confirmation.component'

@Injectable()
export class DeleteWorkspaceConfirmationService {
  constructor(private readonly modalService: NgbModal) {}

  toggle(workspace: WorkspaceSummary): Promise<void> {
    const modalRef = this.modalService.open(
      DeleteWorkspaceConfirmationComponent,
      { size: 'sm', keyboard: false },
    )
    const component =
      modalRef.componentInstance as DeleteWorkspaceConfirmationComponent
    component.workspaceToDelete = workspace
    return modalRef.result
  }
}
